module.exports = __webpack_public_path__ + "static/logo-338df8277e94a45cc7b02bf5504fc3a7.png";